export default {
  methods: {
    setThumbnail(collection) {
      const merged = []
      for (const item of collection) {
        if ((item.thumbnails || []).length > 0) {
          const url = item.url
          merged.push({ ...item.thumbnails[0], url })
        } else {
          merged.push(item)
        }
      }
      return merged
    },
  },
}
